<template>
  <div class="cleaner-signup">
    <div id="secz" class="cleaner-signup__header">
      <div class="cleaner-signup__header--view d-flex align-items-center">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-12 mb-4 text-center">
              <h1 class="main-head" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="500">{{ $t('application') }}</h1>
              <hr class="hr-light" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="500" />
              <h5 class="secondary-head" data-aos="zoom-in-up" data-aos-duration="1500" data-aos-delay="600">www.wavehousecleaning.com</h5>
              <p class="header-description mb-1" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="1000">
                <a class="text-white">{{ $t('scroll_down') }}
                <div class="icon-area mt-2" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="1000">
                  <div class="mouse"></div>
                </div>
              </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner :show="loading" :use-modal="true" message="Please wait"></spinner>
    <div v-for="(section, idx) in sections" :id="'sec'+idx" class="section" :key="'sec'+idx">
      <div v-if="sectionEnabled(idx)" class="cleaner-signup__form py-150">
        <div class="container">
          <template v-if="section.withForm">
            <my-form
              :start-in-edit-mode="true"
              :use-flash-for-errors="false"
              :report-success="false"
              :ref="'form_'+idx"
              :readonly="section.completed"
              :edit-mode="idx == currentIdx">
              <template v-slot:default="{validated, invalid, valid, errors, formIsReadonly }">
                <div class="row">
                  <div class="col-md-12">
                    <section-header @skip="skipSection" :section="section" :step="$t('step', { idx: idx + 1 })" />
                    <div class="row px-4">
                      <div class="col-12 mb-2">
                        <div v-show="section.completed" class="step-notification step-notification--success" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
                          <h4 class="main-sub-head font-weight-light text-center my-0">{{ $t(successMsgKey) }}</h4>
                        </div>
                        <div v-show="validated && invalid && errors" class="step-notification step-notification--error" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
                          <h4 class="main-sub-head font-weight-light text-center my-0">{{ $t('errors.please_fix') }}</h4>
                        </div>
                      </div>
                    </div>
                    <component v-bind:is="section.component + '-step'"
                      :active="idx == currentIdx"
                      :application-id="cleanerApplicationId"
                      :application-data="applicationData"
                      :readonly="section.completed || formIsReadonly"
                      @update="onSectionUpdate(idx,$event)"></component>
                  </div>
                </div>
                <section-hint :section="section" />
              </template>
              <template v-slot:edit-buttons="{ validated, invalid }">
                <next-button :disabled="invalid && validated" :idx="idx * 1" :max-steps="maxSteps" @back="prev(section.component)" />
              </template>
            </my-form>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-md-12">
                <section-header :section="section" @skip="skipSection" :step="$t('step', { idx: idx + 1 })" />
                <div v-show="section.completed" class="row px-4">
                  <div class="col-12 mb-2">
                    <div class="step-notification step-notification--success" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
                      <h4 class="main-sub-head font-weight-light text-center my-0">{{ $t(successMsgKey) }}</h4>
                    </div>
                  </div>
                </div>
                <component v-bind:is="section.component + '-step'"
                  :ref="section.title_key"
                  :application-data="applicationData"
                  :application-id="cleanerApplicationId"
                  :readonly="section.completed || loading"
                  @skip="skipSection"
                  @back="prev(section.component)"
                  @update="onSectionUpdate(idx,$event)"
                ></component>
              </div>
            </div>
            <back-button v-if="idx > 1" @back="prev(section.component)"/>
          </template>
        </div>
        <div class="py-150"></div>
        <section v-show="showSeparator(idx)" :class="'bg-'+((idx % 2) ? '1' : '2')+' py-150'"></section>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/cleaners/api'
import sharedApi from '@/shared/api'
import VueSmoothScroll from 'vue2-smooth-scroll'
import AOS from 'aos'
import 'aos/dist/aos.css'
import Spinner from '@/shared/spinner.vue'
import MyForm from '@/shared/base_form.vue'
import BackButton from './application_form/back_button.vue'
import NextButton from './application_form/next_button.vue'
import SectionHeader from './application_form/section_header.vue'
import SectionHint from './application_form/section_hint.vue'
import LanguageStep from './application_form/language_step.vue'
import AccountStep from './application_form/account_step.vue'
import ConfirmationStep from './application_form/confirmation_step.vue'
import AddressStep from './application_form/address_step.vue'
import AppQuestionsStep from './application_form/app_questions_step.vue'
import AbcTestStep from './application_form/abc_test_step.vue'
import QuizStep from './application_form/quiz_step.vue'
import VouchedStep from './application_form/vouched_step.vue'
import CheckrStep from './application_form/checkr_step.vue'
import DocsStep from './application_form/docs_step.vue'
import ScheduleStep from './application_form/schedule_step.vue'
import SuppliesVacuumStep from './application_form/supplies_vacuum_step.vue'
import esValidationMessages from 'vee-validate/dist/locale/es.json'
import enValidationMessages from 'vee-validate/dist/locale/en.json'
import { localeChanged } from 'vee-validate'
import pubsub_mixin from '@/shared/pubsub_mixin'

export default {
  components: { MyForm, NextButton, Spinner, SectionHeader, SectionHint,
    LanguageStep, AccountStep, ConfirmationStep, AddressStep, AppQuestionsStep, AbcTestStep, QuizStep, VouchedStep, CheckrStep, DocsStep,
    ScheduleStep, SuppliesVacuumStep, BackButton },
  mixins: [pubsub_mixin],
  data() {
    return {
      currentIdx: 0,
      sections: [
        { component: 'language', title_key: "select_language", completed: false },
        { component: 'account', title_key: "personal_information", completed: false, withForm: true },
        { component: 'confirmation', title_key: "confirmation_required", completed: false },
        { component: 'address', title_key: "address_information", completed: false, withForm: true },
        { component: 'app-questions', title_key: "application_questions", completed: false, withForm: true },
        { component: 'abc-test', title_key: "abc_test", completed: false, withForm: true },
        { component: 'quiz', title_key: "cleaning_quiz", completed: false, withForm: true },
        { component: 'vouched', title_key: "id_verificatione", completed: false },
        { component: 'supplies-vacuum', title_key: "supplies_vacuum", completed: false },
        { component: 'checkr', title_key: "criminal_background", completed: false },
        { component: 'docs', title_key: "doc_signatures", completed: false, withForm: true },
        { component: 'schedule', title_key: "choose_your_availability", completed: false, withForm: true }
      ],
      applicationData: { monday: {}, tuesday: {}, wednesday: {}, thursday: {}, friday: {}, saturday: {}, sunday: {} },
      customSuccessMsgKey: null,
      loading: false,
    }
  },
  computed: {
    cleanerApplicationId() {
      if (this.applicationData.cleaner_application_id) {
        return this.applicationData.cleaner_application_id
      }
    },
    currentSection() {
      return this.sections[this.currentIdx]
    },
    currentSectionCompleted() {
      return this.currentSection.completed
    },
    currentSectionComponent() {
      return this.currentSection.component
    },
    pickedAvailability() {
      let hours = 0
      if (this.applicationData) {
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((day) => {
          Object.keys(this.applicationData[day]).forEach((hour) => {
            if (hour > 0) {
              hours++
            }
          })
        })
      }
      return hours
    },
    maxSteps() {
      return Object.entries(this.sections).length
    },
    successMsgKey() {
      if (this.customSuccessMsgKey) {
        return this.customSuccessMsgKey
      }
      return 'step_completed'
    },
  },
  methods: {
    skipSection() {
      if (this.currentSectionComponent == 'checkr') {
        this.completeSection('checkr')
        return
      }
      if (this.currentSectionComponent == 'vouched') {
        this.completeSection('vouched')
        return
      }
    },
    prev(sectionComponentName) {
      const idx = this.sectionIdxByComponent(sectionComponentName)
      if (idx > 0) {
        this.currentIdx = idx - 1
        //// Skip confirmation when navigating back from the address section
        const fromAddressToConfirmation = (sectionComponentName == 'address') && (this.currentSectionComponent == 'confirmation')
        const fromConfirmationToAccount = (sectionComponentName == 'confirmation') && (this.currentSectionComponent == 'account')
        if (fromAddressToConfirmation) {
          this.prev('confirmation')
          return
        }
        if (this.currentSectionComponent == 'supplies-vacuum') {
          this.prev('vouched')
          return
        }
        if (this.currentSectionComponent == 'vouched') {
          this.prev('quiz')
          return
        }
        //// Uncomplete everything expect the confirmation and supplies step when the account is confirmed
        if (this.applicationData.confirmed) {
          if ( (this.currentSectionComponent != 'confirmation') && (this.currentSectionComponent != 'supplies-vacuum') ){
            this.uncompleteSection(this.currentSectionComponent)
          }
        } else {
          //// Uncomplete the account section when it is unconfirmed
          if (this.currentSectionComponent == 'account') {
            this.uncompleteSection(this.currentSectionComponent)
          }
        }
      }
    },
    next(sectionComponentName, opts = {}) {
      const idx = this.sectionIdxByComponent(sectionComponentName)
      if ((idx + 1) < this.maxSteps) {
        this.currentIdx = idx + 1
        if ((!opts.doNotUncomplete) && this.currentSectionCompleted) {
          //// do not uncomplete the confirmation step, unless the account is not confirmed
          const notConfirmationStep = !((this.currentSectionComponent == 'confirmation') && this.applicationData.confirmed)
          const notSuppliesStep = this.currentSectionComponent != 'supplies-vacuum'
          const notVouchedStep = this.currentSectionComponent != 'vouched'
          const notCheckrStep = this.currentSectionComponent != 'checkr'
          if (notConfirmationStep && notSuppliesStep && notCheckrStep && notVouchedStep) {
            this.uncompleteSection(this.currentSectionComponent)
          }
        }
        //// Skip completed steps
        if (this.currentSectionCompleted) {
          this.next(this.currentSectionComponent)
        }
      } else {
        this.allDone()
      }
    },
    scrollTo(step) {
      const id = step >= 0 ? ('sec'+step) : 'secz'
      const observer = new MutationObserver((mutations, obs) => {
      const scrollEl = document.getElementById(id)
        if (scrollEl) {
          this.$smoothScroll({
            scrollTo: document.getElementById(id),
            offset: step == this.maxSteps ? 0 : 50,
          })
          obs.disconnect();
          return;
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true
      });
    },
    uncompleteSection(sectionComponentName) {
      this.updateSection(sectionComponentName, { completed: false })
    },
    completeSection(sectionComponentName, opts = {}) {
      this.completeSectionWithoutJump(sectionComponentName)
      if (opts.noNext) {
        return
      }
      this.next(sectionComponentName, opts)
    },
    completeSectionWithoutJump(sectionComponentName) {
      this.updateSection(sectionComponentName, { completed: true })
    },
    allDone() {
      window.location = '/'
    },
    jumpToFirstUncompletedSection() {
      let idx = this.sections.findIndex(e => e.completed === false) - 1
      if (idx < 0) {
        this.allDone()
        return
      }
      this.next(this.sections[idx].component, { doNotUncomplete: true })
    },
    updateSection(sectionComponentName, changes) {
      const idx = this.sectionIdxByComponent(sectionComponentName)
      this.updateSectionByIdx(idx, changes)
    },
    updateSectionByIdx(idx, changes) {
      Object.keys(changes).forEach((c) => {
        Vue.set(this.sections[idx], c, changes[c])
      })
    },
    sectionEnabled(idx) {
      return idx <= this.currentIdx
    },
    showSeparator(idx) {
      if (idx % 3 == 0) {
        return true;
      }
      return false;
    },
    onSectionUpdate(idx, changes) {
      this.customSuccessMsgKey = null
      if (changes.locale) {
        this.$i18n.locale = changes.locale
        this.completeSection('language')
        localeChanged()
      }

      if (changes.vouchedVerification) {
        if (changes.token) {
          this.loading = true
          const params = { vouched_job_token: changes.token }
          api.postCleanerAppSection('vouched', params).then(response => {
            this.loading = false
            this.completeSection('vouched')
          })
        }
      }

      if (changes.supplies) {
        this.completeSection('supplies-vacuum', { noNext: changes.noNext })
      }

      if (changes.checkrVerification) {
        this.loading = true
        api.postCleanerAppSection('checkr').then(response => {
          this.loading = false
          this.customSuccessMsgKey = response.data.msg_key
          this.completeSection('checkr')
        }, (errors) => {
          this.loading = false
          this.$flasher.errors(errors.response.data.errors)
        })
      }

      if (changes.availability) {
        if (changes.availability.status) {
          if (changes.availability.hour == 0) {
            Object.keys(this.applicationData[changes.availability.day]).forEach((h) => {
              Vue.delete(this.applicationData[changes.availability.day], h * 1)
            })
          } else {
            Vue.delete(this.applicationData[changes.availability.day], 0)
          }
          Vue.set(this.applicationData[changes.availability.day], changes.availability.hour, true)
        } else {
          Vue.delete(this.applicationData[changes.availability.day], changes.availability.hour)
        }
      }
    },
    sectionIdxByComponent(componentKey) {
      const idx = this.sections.findIndex(e => e.component == componentKey)
      if (idx < 0) {
        console.error('Invalid component key:', componentKey)
        return
      }
      return idx
    },
    stepParams(section) {
      let attrs = []
      let params = { cleaner_signup: {} }
      if (this.applicationData.id) {
        params.id = this.applicationData.id
      }
      if (section == 'account') {
        params.locale = this.$i18n.locale
        attrs = ['first_name', 'last_name', 'email', 'phone']
      } else {
        if (this.applicationData.profile_id) {
          params.profile_id = this.applicationData.profile_id
        }
      }
      if (section == 'address') {
        attrs = ['address', 'city', 'state', 'zip_code']
      }
      if (section == 'app-questions') {
        attrs = ['auth', 'transportation', 'paid_experience']
      }
      if (section == 'abc-test') {
        attrs = ['active', 'goal', 'current_services', 'explain_other_jobs']
      }
      if (section == 'quiz') {
        attrs = ['quiz_easy_off_effect', 'quiz_hardwood', 'quiz_late']
      }
      if (section == 'docs') {
        attrs = ['business_name', 'business_description', 'website', 'business_type']
      }
      if (section == 'schedule') {
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((day) => {
          params.cleaner_signup[day] = Object.keys(this.applicationData[day])
          if (params.cleaner_signup[day].length == 0) {
            params.cleaner_signup[day] = [0]
          }
        })
      }
      attrs.forEach((attr) => {
        params.cleaner_signup[attr] = this.applicationData[attr]
      })
      return params
    },
    submit(e) {
      let sectionIdx = $(e.target).parents('.section').attr('id').replace('sec', '') * 1
      this.loading = true
      const section = this.sections[sectionIdx].component
      this.uncompleteSection(section)
      this.customSuccessMsgKey = null
      return new Promise((resolve, reject) => {
        if ( (section == 'schedule') && (this.pickedAvailability == 0) ) {
          this.loading = false
          reject({errors: [this.$t('errors.cleaner_application.you_need_to_be_available')]})
        } else {
          api.postCleanerAppSection(section, this.stepParams(section)).then(response => {
            this.customSuccessMsgKey = response.data.msg_key
            for(let key in response.data) {
              Vue.set(this.applicationData, key, response.data[key])
            }
            this.loading = false
            this.completeSection(section)
            if (section == 'schedule') {
              this.allDone()
            }
            resolve()
          }, (errors) => {
            this.loading = false
            if (errors.response.status == 401) {
              window.location = '/'
            } else {
              this.$flasher.errors(errors.response.data.errors)
            }
            reject(errors)
          })
        }
      })
    },
    subscribeUploads() {
      if (!this.subscribed && this.cleanerApplicationId) {
        this.fayeSubscribe('/cleaner_applications/' + this.cleanerApplicationId, 'uploading', (channel, msg) => {
          if (msg.upload == 'started') {
            this.loading = true
          }
          if (msg.upload == 'completed') {
            this.loading = false
          }
        })
        this.subscribed = true
      }
    }
  },
  created() {
    sharedApi.getLocales([
      'shared.application', 'shared.required', 'shared.is_required', 'shared.days', 'shared.yes', 'shared.no',
      'shared.first_name', 'shared.last_name', 'shared.email', 'shared.phone', 'shared.address',
      'shared.for_more_info', 'cleaner_application']).then(response => {
      for(var localeKey in response.data) {
        let translations = response.data[localeKey]
        if (localeKey == 'en') {
          translations.validations = { messages: enValidationMessages.messages }
        }
        if (localeKey == 'es') {
          translations.validations = { messages: esValidationMessages.messages }
        }
        this.$i18n.mergeLocaleMessage(localeKey, translations)
      }
      localeChanged()
    })
  },
  mounted() {
    AOS.init({once: 'true'})
    Vue.use(VueSmoothScroll, {
      duration: 2000,
      updateHistory: false,
    })
    this.scrollTo(-1)
    if ($cleanerId) {
      this.loading = true
      api.getCleanerApp().then(response => {
        for(let key in response.data) {
          if (key == 'completed_sections') {
            response.data[key].forEach((sectionComponentName) => {
              this.completeSectionWithoutJump(sectionComponentName)
            })
            this.jumpToFirstUncompletedSection()
          } else {
            Vue.set(this.applicationData, key, response.data[key])
          }
        }
        this.$i18n.locale = this.applicationData.locale
        this.loading = false
      }, (errors) => {
        this.loading = false
        if (errors.response.status == 401) {
          window.location = '/'
        } else {
          this.$flasher.errors(errors.response.data.errors)
        }
      })
    }
    this.subscribeUploads()
  },
  watch: {
    cleanerApplicationId(newValee) {
      this.subscribeUploads()
    },
    currentIdx(newValue, oldValue) {
      this.scrollTo(newValue)
    }
  }
}
</script>
